import useCardStore from "./store/shoppingCardStore";
import { Link } from "react-router-dom";
import styles from "./styles/CartPage.module.css";
import backarrow from "./images/back arrow.png";
import emptycart from "./images/empty-cart.png";
import {
  FiPlus,
  FiMinus,
  FiTrash2,
  FiArrowLeft,
  FiShoppingBag,
} from "react-icons/fi";

const CartPage = () => {
  const { items, itemscount, removeItem, addItem, resetItems } = useCardStore();
  const itemscountArray = Object.keys(itemscount);

  const totalAmount = items.reduce(
    (sum, item) => sum + item.price * itemscount[item.id],
    0
  );

  return (
    <div className={styles.cartContainer}>
      <div className={styles.cartHeader}>
        <Link to="/محصولات/" className={styles.backButton}>
          <FiArrowLeft size={20} />
          <span>بازگشت به محصولات</span>
        </Link>
        <h1 className={styles.cartTitle}>سبد خرید شما</h1>
      </div>

      {items.length > 0 ? (
        <>
          <div className={styles.itemsContainer}>
            {items.map((item) => (
              <div key={item.id} className={styles.cartItem}>
                <img
                  src={item.image[0]}
                  alt={item.name}
                  className={styles.itemImage}
                />

                <div className={styles.itemDetails}>
                  <h3 className={styles.itemName}>{item.name}</h3>
                  <p className={styles.itemPrice}>
                    {item.price.toLocaleString()} تومان
                  </p>

                  <div className={styles.quantityControl}>
                    <button
                      onClick={() => removeItem(item.id)}
                      className={styles.quantityButton}
                    >
                      {itemscount[item.id] > 1 ? <FiMinus /> : <FiTrash2 />}
                    </button>

                    <span className={styles.quantityValue}>
                      {itemscount[item.id]}
                    </span>

                    <button
                      onClick={() => addItem(item)}
                      className={styles.quantityButton}
                    >
                      <FiPlus />
                    </button>
                  </div>

                  <p className={styles.itemTotal}>
                    {(item.price * itemscount[item.id]).toLocaleString()} تومان
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.cartSummary}>
            <div className={styles.summaryRow}>
              <span>مجموع:</span>
              <span>{totalAmount.toLocaleString()} تومان</span>
            </div>

            <Link to="/تکمیل خرید/" className={styles.checkoutButton}>
              <FiShoppingBag />
              <span>تکمیل سفارش</span>
            </Link>
          </div>
        </>
      ) : (
        <div className={styles.emptyCart}>
          <img
            src={emptycart}
            alt="سبد خرید خالی"
            className={styles.emptyCartImage}
          />
          <h2 className={styles.emptyCartTitle}>سبد خرید شما خالی است</h2>
          <p className={styles.emptyCartText}>
            می‌توانید برای مشاهده محصولات به صفحه فروشگاه مراجعه کنید
          </p>
          <Link to="/محصولات/" className={styles.shopButton}>
            مشاهده محصولات
          </Link>
        </div>
      )}
    </div>
  );
};

export default CartPage;
